import { hasValue } from "@/Utils/Objects";

export const createRipple = (event: MouseEvent, element: HTMLHtmlElement) => {
  if (hasValue(element)) {
    if (element.getElementsByClassName("ripple").length > 0) {
      element.removeChild(element.getElementsByClassName("ripple")[0]);
    }

    const circle = document.createElement("div");
    const position = element.getBoundingClientRect();
    const d = Math.max(element.clientWidth, element.clientHeight);

    element.appendChild(circle);

    circle.style.width = circle.style.height = d + "px";

    circle.style.left = event.clientX - position.left - d / 2 + "px";
    circle.style.top = event.clientY - position.top - d / 2 + "px";

    circle.classList.add("ripple");
  }
};
